// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: 1X0CJgue1Nt5
import * as React from "react";
import {
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  renderPlasmicSlot
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import PaidStatusCard from "../../PaidStatusCard"; // plasmic-import: WFtR3jkCymbz/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicPaymentsListCard.module.css"; // plasmic-import: 1X0CJgue1Nt5/css

createPlasmicElementProxy;

export const PlasmicPaymentsListCard__VariantProps = new Array();

export const PlasmicPaymentsListCard__ArgProps = new Array(
  "amount",
  "clientCompany",
  "paymentType",
  "dateCreated"
);

const $$ = {};

function PlasmicPaymentsListCard__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <Stack__
      as={"div"}
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      hasGap={true}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.root
      )}
    >
      <div className={classNames(projectcss.all, sty.freeBox__rqTni)}>
        {renderPlasmicSlot({
          defaultContents: "$1043.00",
          value: args.amount,
          className: classNames(sty.slotTargetAmount)
        })}
      </div>
      <div
        data-plasmic-name={"clientCompany"}
        data-plasmic-override={overrides.clientCompany}
        className={classNames(projectcss.all, sty.clientCompany)}
      >
        {renderPlasmicSlot({
          defaultContents: "Nike",
          value: args.clientCompany,
          className: classNames(sty.slotTargetClientCompany)
        })}
      </div>
      <div
        data-plasmic-name={"statusCardStack"}
        data-plasmic-override={overrides.statusCardStack}
        className={classNames(projectcss.all, sty.statusCardStack)}
      >
        <PaidStatusCard
          data-plasmic-name={"paidStatusCard"}
          data-plasmic-override={overrides.paidStatusCard}
          className={classNames("__wab_instance", sty.paidStatusCard)}
        />
      </div>
      <div className={classNames(projectcss.all, sty.freeBox__rrnYl)}>
        {renderPlasmicSlot({
          defaultContents: "Subscription Payment",
          value: args.paymentType,
          className: classNames(sty.slotTargetPaymentType)
        })}
      </div>
      <div className={classNames(projectcss.all, sty.freeBox__j2Fbk)}>
        {renderPlasmicSlot({
          defaultContents: "Dec 28th, 12:25 AM",
          value: args.dateCreated,
          className: classNames(sty.slotTargetDateCreated)
        })}
      </div>
    </Stack__>
  );
}

const PlasmicDescendants = {
  root: ["root", "clientCompany", "statusCardStack", "paidStatusCard"],
  clientCompany: ["clientCompany"],
  statusCardStack: ["statusCardStack", "paidStatusCard"],
  paidStatusCard: ["paidStatusCard"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicPaymentsListCard__ArgProps,
          internalVariantPropNames: PlasmicPaymentsListCard__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicPaymentsListCard__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicPaymentsListCard";
  } else {
    func.displayName = `PlasmicPaymentsListCard.${nodeName}`;
  }
  return func;
}

export const PlasmicPaymentsListCard = Object.assign(
  // Top-level PlasmicPaymentsListCard renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    clientCompany: makeNodeComponent("clientCompany"),
    statusCardStack: makeNodeComponent("statusCardStack"),
    paidStatusCard: makeNodeComponent("paidStatusCard"),
    // Metadata about props expected for PlasmicPaymentsListCard
    internalVariantProps: PlasmicPaymentsListCard__VariantProps,
    internalArgProps: PlasmicPaymentsListCard__ArgProps
  }
);

export default PlasmicPaymentsListCard;
/* prettier-ignore-end */
